// extracted by mini-css-extract-plugin
module.exports = {"DatabaseInformationVersion":"DatabaseInformationVersion_nihwz"};